<template>
  <section class="gridClass my-8">
    <section class="relative">
      <component
        :is="titleTag"
        class="text-base laptop:text-2xl font-bold text-center mb-10 laptop:mb-14"
      >
        {{ title ? title : "بسته های مرکز تلفن ابری نواتل" }}
      </component>
      <div
        class="grid grid-cols-1 tablet:grid-cols-2 laptop-m:grid-cols-4 gap-14 laptop:gap-6"
      >
        <div
          class="w-[90%] mx-auto laptop-m:w-[96%] p-4 custom-shadow relative rounded-xl"
          v-for="item in items"
          :key="item.id"
        >
          <ProductPlan :item="item" :shoppingSrc="shoppingSrc" />
        </div>
      </div>
    </section>
    <div
      v-if="!hideCompare"
      class="py-6 px-2 mt-8 mb-12 bg-gray-200 flex flex-col laptop:flex-row justify-center items-center"
    >
      <span class="me-6 font-bold text-black text-sm">
        در مورد بسته ها نیاز به اطلاعات بیشتر دارید؟
      </span>
      <BaseButton
        @click="isModalShow = true"
        isLean
        size="2xl"
        :text="compareText || 'مقایسه بسته ها'"
        color="primary"
      />
    </div>
    <SectionModalCompare
      :isShow="isModalShow"
      @close="isModalShow = false"
      :data="compareData ? compareData : null"
      :id="id"
    />
  </section>
</template>

<script setup>
const props = defineProps({
  items: Array,
  title: String,
  fullButton: Boolean,
  onlyOnlineBtn: Boolean,
  hideCompare: Boolean,
  shoppingSrc: {
    type: String,
    default: "/online-shopping/buy/",
  },
  compareData: {
    type: Object,
    required: false,
  },
  compareText: String,
  submitOrderBtnText: String,
  id: String,
  titleTag: {
    type: String,
    default: "div",
  },
});

const { formatPrice } = useInputHelpers();

const isModalShow = ref(false);

const isMainModalShowState = useState("isMainModalShow");

const showMainModal = () => {
  isMainModalShowState.value = true;
};

const getOffPrice = (item) => {
  let totalPrice = +item.price1;
  // if(item.price2) {
  //   totalPrice += +item.price2
  // }
  const totalOffPrice = (totalPrice * item.off) / 100;
  const price = formatPrice(totalPrice - totalOffPrice);
  return price;
};

const getSetupOffPrice = (item) => {
  let totalPrice = +item.price2;
  const totalOffPrice = (totalPrice * item.off) / 100;
  console.log(totalOffPrice);
  const price = formatPrice(totalPrice - totalOffPrice);
  console.log(price);
  return price;
};

const getShoppingSrc = (item) => {
  let src = props.shoppingSrc;
  // if (item.label === "بسته تنگستن" || item.label === "بسته بیسموت") {
  //   src = "#";
  // }
  return src;
};
</script>
